"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
let RiskLogOptions = class extends Vue {
  computed() {
    item:
      () => {
        return this._item;
      };
  }
  readStatus(row) {
    return __async(this, null, function* () {
      console.dir(row);
      try {
        let confirm = yield this.$confirm("\u786E\u8BA4\u5DF2\u8BFB\u6B64\u6761\u4FE1\u606F?", this.$t("risklogoptions.confirm_that_you_have_read_this_message"), {
          customClass: "confirm-dark",
          confirmButtonText: this.$t("risklogoptions.determine"),
          cancelButtonText: this.$t("risklogoptions.cancel"),
          confirmButtonClass: "btn-main",
          cancelButtonClass: "btn-dark",
          roundButton: true
        });
        const response = yield API.put(`api://base.auth/api/v7/risk_event_logs/${row.guid}/operate`);
        this._item.risk_event_status = 1;
        this.$message.success(this.$t("risklogoptions.operation_successful"));
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  PropSync("item")
], RiskLogOptions.prototype, "_item", 2);
RiskLogOptions = __decorateClass([
  Component({
    components: {}
  })
], RiskLogOptions);
export {
  RiskLogOptions as default
};
